import { render, staticRenderFns } from "./TeaserEventsHomeOverview.vue?vue&type=template&id=53090600"
import script from "./TeaserEventsHomeOverview.vue?vue&type=script&lang=ts"
export * from "./TeaserEventsHomeOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports